module.exports = __webpack_public_path__ + "img/ccfound.56f77af8.png";